// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.placeholders-enabled .placeholder {
  cursor: pointer;
  background-color: var(--t-swatches-blue-50);
  border: 1px solid var(--t-swatches-blue-300);
  border-radius: 4px;
}

.placeholders-enabled .placeholder:empty::before,
.placeholders-enabled .placeholder:empty::after {
  color: var(--t-swatches-blue-600);
  font-weight: bold;
}

/*
 * The chip renders the resolved question label, falling back to the raw ref when no question list
 * is wired up. Link state distinguishes "no question picked yet" from "the ref resolves to nothing".
 */
.placeholders-enabled .placeholder:empty::before {
  content: '{{' attr(data-placeholder-label);
}

.placeholders-enabled .placeholder:empty::after {
  content: '}}';
}

.placeholders-enabled .placeholder[data-placeholder-state='unconfigured'] {
  background-color: var(--t-semantic-surface-sunken);
  border: 1px dashed var(--t-swatches-gray-400);
}

.placeholders-enabled .placeholder[data-placeholder-state='unconfigured']:empty::before,
.placeholders-enabled .placeholder[data-placeholder-state='unconfigured']:empty::after {
  color: var(--t-swatches-gray-700);
}

.placeholders-enabled .placeholder[data-placeholder-state='broken'] {
  background-color: var(--t-swatches-red-50);
  border: 1px solid var(--t-swatches-red-300);
}

.placeholders-enabled .placeholder[data-placeholder-state='broken']:empty::before,
.placeholders-enabled .placeholder[data-placeholder-state='broken']:empty::after {
  color: var(--t-swatches-red-700);
}
`, "",{"version":3,"sources":["webpack://./shared/domains/pleditor@next/plugins/TemplateEditorPlugins/Placeholder/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,2CAA2C;EAC3C,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;;EAEE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;;;EAGE;AACF;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kDAAkD;EAClD,6CAA6C;AAC/C;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;;EAEE,gCAAgC;AAClC","sourcesContent":[".placeholders-enabled .placeholder {\n  cursor: pointer;\n  background-color: var(--t-swatches-blue-50);\n  border: 1px solid var(--t-swatches-blue-300);\n  border-radius: 4px;\n}\n\n.placeholders-enabled .placeholder:empty::before,\n.placeholders-enabled .placeholder:empty::after {\n  color: var(--t-swatches-blue-600);\n  font-weight: bold;\n}\n\n/*\n * The chip renders the resolved question label, falling back to the raw ref when no question list\n * is wired up. Link state distinguishes \"no question picked yet\" from \"the ref resolves to nothing\".\n */\n.placeholders-enabled .placeholder:empty::before {\n  content: '{{' attr(data-placeholder-label);\n}\n\n.placeholders-enabled .placeholder:empty::after {\n  content: '}}';\n}\n\n.placeholders-enabled .placeholder[data-placeholder-state='unconfigured'] {\n  background-color: var(--t-semantic-surface-sunken);\n  border: 1px dashed var(--t-swatches-gray-400);\n}\n\n.placeholders-enabled .placeholder[data-placeholder-state='unconfigured']:empty::before,\n.placeholders-enabled .placeholder[data-placeholder-state='unconfigured']:empty::after {\n  color: var(--t-swatches-gray-700);\n}\n\n.placeholders-enabled .placeholder[data-placeholder-state='broken'] {\n  background-color: var(--t-swatches-red-50);\n  border: 1px solid var(--t-swatches-red-300);\n}\n\n.placeholders-enabled .placeholder[data-placeholder-state='broken']:empty::before,\n.placeholders-enabled .placeholder[data-placeholder-state='broken']:empty::after {\n  color: var(--t-swatches-red-700);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
